import React, { useState } from 'react'

import { BulletinType } from '../../../common/validations'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import { useAPIGetBulletinSuspense } from 'api/apiHooks/useAPIGetBulletin'
import { useCurrentBulletin } from 'hooks/useCurrentBulletin/useCurrentBulletin'
import { Language } from 'i18n/i18n'

interface Data {
  bulletin: BulletinType
  onLanguageChange: (language: BulletinType['language']) => void
}

export const BulletinViewDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { bulletinUuid } = useCurrentBulletin()
  const { currentContractId } = useCurrentContract()
  const [languageOverride, setLanguageOverride] = useState<
    Language | undefined
  >(undefined)

  const { data: bulletin } = useAPIGetBulletinSuspense(
    currentContractId,
    bulletinUuid,
    languageOverride
  )

  return children({ bulletin, onLanguageChange: setLanguageOverride })
}
